export const DeliveryMethods = [
  { _id: 'hybrid', name: 'Hybrid' },
  { _id: 'inperson', name: 'In-Person' },
  { _id: 'virtual', name: 'Virtual' },
];
